import {useNavigate, useSearchParams} from "react-router-dom";
import {geofenceSiteGroupSelector, useGetGeofenceSiteGroupQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {GeofenceSiteGroupProfile} from "../../components/profile/GeofenceSiteGroupProfile/GeofenceSiteGroupProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const GeofenceSiteGroupProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.geofencesitegroup", "Geofence Site Group") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <GeofenceSiteGroupProfilePage id={id}/>;
};

export const GeofenceSiteGroupProfilePage = (props: Props) => {
  const {id} = props;

  const selectGeofenceSiteGroup = useMemo(() => {
    return geofenceSiteGroupSelector()
  }, []);

  const {geofenceSiteGroup, isFetching} = useGetGeofenceSiteGroupQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      geofenceSiteGroup: selectGeofenceSiteGroup(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["geofencesitegroup_view"]} entity={geofenceSiteGroup} isLoading={isFetching}>
      {(entity) => (
        <GeofenceSiteGroupProfile geofenceSiteGroup={entity}/>
      )}
    </EntityProfilePage>
  )
};
